export const SLIPS = {
  SLIPS_SET_SELECTED: "SLIPS_SET_SELECTED",
  SLIPS_CLEAR_SELECTED: "SLIPS_CLEAR_SELECTED",
};
